import { fetchRS } from "../utils/fetchRS";

export interface LicenciaEstado {
  configurada?: boolean;
  id?: number;
  cliente?: string | null;
  numero_licencia?: string | null;
  plan?: string | null;
  fecha_inicio?: string | null;
  fecha_vencimiento?: string | null;
  fecha_ultimo_pago?: string | null;
  dias_alerta?: number;
  frecuencia_modal_minutos?: number;
  dias_restantes?: number | null;
  licencia_expirada?: boolean;
  debe_bloquear?: boolean;
  mostrar_modal_pago_pendiente?: boolean;
  pago_pendiente?: boolean;
  bloquear_al_vencer?: boolean;
  monto_renovacion?: string | number | null;
  moneda?: string | null;
  mensaje?: string | null;
  contacto_renovacion?: string | null;
}

export const getLicenciaEstado = (): Promise<LicenciaEstado> =>
  fetchRS(`${process.env.REACT_APP_API_URL}/licencia/estado`);
